import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { CityApi } from '@/modules/counterparty/api/city.api.ts';

export class CityQueryOptions {
  static BASE_KEY = 'city';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, CityQueryOptions.BASE_KEY],
      queryFn: (meta) => CityApi.getList(signal ?? meta.signal),
    });
  }
}
